var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper",class:{ isDark: _vm.isDark }},[_c('Sidebar',{staticClass:"LeFtNav"}),_c('div',{staticClass:"right"},[(_vm.isShowHeader)?_c('Header',{staticClass:"Header"}):_vm._e(),_c('div',{staticClass:"main",class:{ isShowHeader: _vm.isShowHeader }},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }